export default "__VITE_ASSET__0yMxH33B__"